import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { micIcon, sendIcon, unclickableSendIcon } from "../../assets/icons";
import { setQuery, stopQuery } from "../../features/queryAnsSlice";
import { fetchAnswerMiddleware, abortCurrentQuery } from "../../middlewares/fetchAnswerMiddleware";
import { useEffect, useState } from "react";
import "./searchBar.css";
import { handleGeminiTranscription } from "../../utils/handleGeminiTranscription";

function SearchBar(props) {
  const { id, inputValue, setInputValue } = props;
  const [isSendClickable, setIsSendClickable] = useState(false);
  const [isListening, setIsListening] = useState(false);



  const loading = useAppSelector((state) => state.queryAnsReducer.loading);
  const dispatch = useAppDispatch();

  const handleStopQuery = () => {
    dispatch(stopQuery());
    abortCurrentQuery();
  };

  //handle user input
  const handleInput = (e) => {
    setInputValue(e.target.value);
  };

  //set send button clickable or not
  useEffect(
    () =>
      setIsSendClickable(inputValue !== "" && inputValue !== "Listening..."),
    [inputValue]
  );

  //handle send button click
  const handleQuery = (text) => {
    const queryText = (typeof text === "string" ? text : inputValue).trim();
    if (!queryText || loading) return;

    const requestId = Date.now().toString() + Math.random().toString(36).substring(7);
    dispatch(setQuery(queryText));
    dispatch(fetchAnswerMiddleware(queryText, requestId));
    setInputValue("");
  };

  //handle Enter press
  const handleEnter = (e) => {
    if (e.key === "Enter" && isSendClickable) {
      handleQuery();
    }
  };

  //handle mic button click
  const handleMicClick = () => {
    if (isListening || loading) return;

    setInputValue("Listening...");
    setIsListening(true);
    setIsSendClickable(false);

    handleGeminiTranscription(() => {
      setInputValue("Transcribing...");
    })
      .then((transcribedText) => {
        setIsListening(false);
        if (transcribedText && transcribedText.trim().length > 0) {
          setInputValue(transcribedText);
          // Auto-submit disabled allows user to edit
          // handleQuery(transcribedText); 
          // Focus the input field
          document.querySelector(".txt-input")?.focus();
        } else {
          setInputValue('');
        }
      })
      .catch((error) => {
        setIsListening(false);
        setInputValue('');
        console.error('Gemini transcription error:', error);
      });
  };

  //  useEffect(()=>setInputValue(sentence),[sentence]);

  return (
    <div id={id} className="searchBar-container">
      <input
        className="txt-input"
        type="text"
        value={inputValue}
        placeholder="Explore the diverse themes within Jeevika"
        onChange={handleInput}
        onKeyDown={handleEnter}
      ></input>

      <div className="searchbar-icon-container">
        {loading ? (
          <button className="searchbar-stop-btn" onClick={handleStopQuery}>
            Stop
          </button>
        ) : isSendClickable ? (
          <img
            className="searchbar-icon"
            id="send-btn"
            src={sendIcon}
            alt="send"
            onClick={handleQuery}
          />
        ) : (
          <img
            className="searchbar-icon"
            id="unclickable-send-btn"
            src={unclickableSendIcon}
            alt="send"
          />
        )}

        {!loading && (
          <img
            className={`searchbar-icon ${isListening ? 'listening' : ''}`}
            id='mic-btn'
            src={micIcon}
            alt="mic"
            onClick={handleMicClick}
          />
        )}
      </div>
    </div>
  );
}
export default SearchBar;
